import { DtoFactory } from '../dto-factory';
import { BoCartographyResourceSiteInterface } from '../../module/cartography/interface/back-office/cartography-resource/bo-cartography-resource-site.interface';
import { BoCartographyGroupInterface } from '../../module/cartography/interface/back-office/bo-cartography-group.interface';
import { BoCartographyResourceMatInterface } from '../../module/cartography/interface/back-office/cartography-resource/bo-cartography-resource-mat.interface';
import { BoCartographyResourceBbxInterface } from '../../module/cartography/interface/back-office/cartography-resource/bo-cartography-resource-bbx.interface';
import { BoCartographyPositionMatInterface } from '../../module/cartography/interface/back-office/cartography-position/bo-cartography-position-mat.interface';
import { BoCartographyPositionBbxInterface } from '../../module/cartography/interface/back-office/cartography-position/bo-cartography-position-bbx.interface';
import { BoCartographyStatusBbxInterface } from '../../module/cartography/interface/back-office/bo-cartography-status-bbx.interface';

export class ToolsDtoFactory {
  public static getCartographySiteDtoFactory() {
    return new DtoFactory<BoCartographyResourceSiteInterface>(
      'map/resources/site',
    );
  }

  public static getCartographyGroupSiteDtoFactory() {
    return new DtoFactory<BoCartographyGroupInterface>('map/groups/site');
  }

  public static getCartographyGroupMatDtoFactory() {
    return new DtoFactory<BoCartographyGroupInterface>('map/groups/tag');
  }

  static getCartographyResourceMatDtoFactory() {
    return new DtoFactory<BoCartographyResourceMatInterface>(
      'map/resources/tag',
    );
  }

  static getCartographyGroupBbxDtoFactory() {
    return new DtoFactory<BoCartographyGroupInterface>('map/groups/bbx');
  }

  static getCartographyResourceBbxDtoFactory() {
    return new DtoFactory<BoCartographyResourceBbxInterface>(
      'map/resources/bbx',
    );
  }

  static getCartographyPositionTagFactory() {
    return new DtoFactory<BoCartographyPositionMatInterface>(
      'map/position/tag',
    );
  }

  static getCartographyPositionBbxDtoFactory() {
    return new DtoFactory<BoCartographyPositionBbxInterface>(
      'map/position/bbx',
    );
  }

  static getCartographyStatusBbxDtoFactory() {
    return new DtoFactory<BoCartographyStatusBbxInterface>(
      'map/status-resources/bbx',
    );
  }
}
